import React, { useState } from 'react';
import Styled from 'styled';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import FetchMoreButton from 'four-nets/ui-v2/fetch-more-button/fetch-more-button';
import Avatar from 'four-nets/avatar/avatar';
import { displayedName } from 'four-nets/user/utils';

import defaultStyles from './author-liked-photoblogs.scss';
import { AuthorLikedPhotoblogsFragment } from './author-liked-photoblogs.graphql';

export interface Props extends AuthorLikedPhotoblogsFragment {
    styles: typeof defaultStyles;
    onMorePhotoBlogs?: () => void;
}

function AuthorLikedPhotoblogs(props: Props) {
    const { styles, likedPhotoBlogs, onMorePhotoBlogs, likedPhotoBlogsCount } = props;
    const [loadingOnMorePhotoBlogs, setLoadingOnMorePhotoBlogs] = useState(false);

    if (likedPhotoBlogs == null || likedPhotoBlogs.edges == null || likedPhotoBlogs.edges.length <= 0) {
        return null;
    }

    return (
        <div className={styles.groups}>
            <div className={styles.sectionTitle}>
                <FormattedMessage id='SUBSCRIBED_PHOTOBLOGS_WITH_COUNT' values={{ count: likedPhotoBlogsCount }} />
            </div>
            {likedPhotoBlogs.edges.map(edge => {
                if (!edge || !edge.node || !edge.node.user) {
                    return null;
                }
                const user = edge.node.user;

                return (
                    <div className={styles.halfRow} key={user.id}>
                        <Avatar style={{ avatar: styles.smallAvatar }} user={user} />
                        <Link
                            to={
                                user.profile && user.profile.isVendor
                                    ? `/catalog/vendor/${user.username}/`
                                    : `/blog/${user.username}/`
                            }
                            className={styles.usernameElipsis}
                        >
                            {displayedName(user)}
                        </Link>
                    </div>
                );
            })}
            {onMorePhotoBlogs ? (
                <FetchMoreButton
                    style={{ button: styles.fetchMoreButton }}
                    disabled={loadingOnMorePhotoBlogs}
                    loading={loadingOnMorePhotoBlogs}
                    onClick={() => {
                        setLoadingOnMorePhotoBlogs(true);
                        onMorePhotoBlogs();
                    }}
                />
            ) : null}
        </div>
    );
}

export default Styled(defaultStyles)(AuthorLikedPhotoblogs);
